import Menu from "@DSG/MobiusOverrides/Icons/Menu";
import { getCookie } from "@insite/client-framework/Common/Cookies";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
/* eslint-disable spire/export-styles */
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByNodeId, useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { NavigationModeCookieName } from "@insite/content-library/Components/NavigationModeMenu";
import Accordion from "@insite/mobius/Accordion";
import { ManagedAccordionSection } from "@insite/mobius/AccordionSection";
import Icon from "@insite/mobius/Icon";
import Link from "@insite/mobius/Link";
import * as cssLinter from "css";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

const enum fields {
    depth = "depth",
    nodeId = "nodeId",
    leftMargin = "leftMargin",
    marginBottom = "marginBottom",
    customCSS = "customCSS",
    payMyBillText = "payMyBillText",
    openLinkInNewWindow = "openLinkInNewWindow",
    importErrorLogsText = "importErrorLogsText",
    importErrorLogsLink = "importErrorLogsLink",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.depth]: number;
        [fields.nodeId]: LinkFieldValue;
        [fields.leftMargin]: number;
        [fields.marginBottom]: number;
        [fields.customCSS]: string;
        [fields.payMyBillText]: string;
        [fields.openLinkInNewWindow]: boolean;
        [fields.importErrorLogsText]:string;
        [fields.importErrorLogsLink]:LinkFieldValue;
    };
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => ({
    rootPageLink: getPageLinkByNodeId(state, ownProps.fields.nodeId?.value || getCurrentPage(state).nodeId),
    displayChangeCustomerLink: state.context.session?.displayChangeCustomerLink || false,
    isSessionCreated: state.context.session?.userRoles,
    customSettings: getSettingsCollection(state).customSettings,
     session : getSession(state)
   // importErrorLogPageLink:useGetLink(ownProps.fields.importErrorLogsLink).url,
});

interface ListStyleProp {
    leftMargin: number;
    marginBottom: number;
}

const ListStyle = styled.ul<ListStyleProp>`
    margin-left: ${props => props.leftMargin}px;
    li {
        margin-bottom: 0;
    }
`;

const mapDispatchToProps = {};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export const NavigationList = (props: Props) => {
    const impersonateUserId = getCookie("ImpersonateBy") ? getCookie("ImpersonateBy") : "";
    if (!props.rootPageLink || !props.rootPageLink.children) {
        return null;
    }

    const customCssWrapper = {
        css: css`
            ${props.fields.customCSS}
        `,
    };
    const customCssLinkWrapper = {
        css: css`
            [class*="Wrapper"] {
                [class*="StyledButton"] {
                    margin: -8px -24px 8px -20px;
                    width: auto;
                    [class*="TypographyStyle"] {
                        padding: 10px 24px 10px 20px;
                    }
                }
            }
        `,
    };
    // const getPayMyBillItem = (): PageLinkModel => {
    //     return {
    //         title: "Pay mybill",
    //         url:"",
    //         id:"",
    //     };
    // }
    // props.rootPageLink.children.push(getPayMyBillItem());
    const renderLink = (pageLink: PageLinkModel, currentDepth: number) => {
        if (currentDepth > props.fields.depth) {
            return;
        }

        if (
            pageLink.excludeFromNavigation ||
            (pageLink.type === "ChangeCustomerPage" && !props.displayChangeCustomerLink)
        ) {
            return;
        }

        if (pageLink.type === "VmiUsersPage") {
            const currentMode = getCookie(NavigationModeCookieName);
            if (!currentMode || currentMode === "Storefront") {
                return;
            }
        }
        const nextDepth = currentDepth + 1;

        return (
            <>
                <li key={pageLink.id} className="navigation-list-item">
                    <Link
                        className="navigation-list-link"
                        data-test-selector={`navigationList-${pageLink.title}`}
                        href={pageLink.url}
                    >
                        {pageLink.title}
                    </Link>
                    {pageLink.children && pageLink.children.length > 0 && (
                        <ListStyle
                            marginBottom={props.fields.marginBottom}
                            leftMargin={props.fields.leftMargin}
                            key={pageLink.id}
                        >
                            {pageLink.children.map(link => renderLink(link, nextDepth))}
                        </ListStyle>
                    )}
                </li>
            </>
        );
    };
    let isEnablePayBillTrust = false;
    if (
        props.isSessionCreated != null &&
        props.isSessionCreated !== undefined &&
        props.isSessionCreated.indexOf("Billtrust") > -1
    ) {
        isEnablePayBillTrust = true;
    }
    const setting = props.customSettings as any;
    const billTrustUrl = setting ? setting.billTrustLoginLink : "";
    const consolUserAllowedList = setting? setting.billtrustAllowedUsers.toLocaleLowerCase().split(',') : "";
    let isConsoleUserAllowedForBillTrust = false;
    if (consolUserAllowedList && consolUserAllowedList.length > 0) {
        isConsoleUserAllowedForBillTrust = consolUserAllowedList.includes(impersonateUserId?.toLocaleLowerCase());
    }
  
    const importErrorLogPageLink= useGetLink(props.fields.importErrorLogsLink).url;
    const isImportErrorLogsRole = props.session.userRoles?.toLowerCase().indexOf("importerror_view") !== -1;
   
    return (
        <Accordion
            headingLevel={2}
            data-test-selector="navigationlink"
            // {...styles}
            className="quick-links-container"
        >
            <Icon src={Menu} className="mobile-only" />
            <ManagedAccordionSection
                initialExpanded={true}
                title={translate("Account Quick Links")}
                data-test-selector="navigationlink"
            >
                <StyledWrapper {...customCssWrapper}>
                    <ListStyle
                        className="navigation-list"
                        marginBottom={props.fields.marginBottom}
                        leftMargin={props.fields.leftMargin}
                        data-test-selector="navigationList"
                    >
                        {props.rootPageLink.children.map(link => renderLink(link, 1))}
                        {isEnablePayBillTrust && (!impersonateUserId || isConsoleUserAllowedForBillTrust)  && props.fields.payMyBillText && (
                            <li className="navigation-list-item">
                                {isEnablePayBillTrust && billTrustUrl && billTrustUrl.length > 0 && (
                                    <Link
                                        className="navigation-list-link"
                                        data-test-selector={`navigationList-${props.fields.payMyBillText}`}
                                        href={billTrustUrl}
                                        target={props.fields.openLinkInNewWindow ? "_blank" : ""}
                                    >
                                        {props.fields.payMyBillText}
                                    </Link>
                                )}
                            </li>
                        )}
                        {isImportErrorLogsRole && (
                            <Link
                                className="navigation-list-link"
                                data-test-selector={`navigationList-${props.fields.importErrorLogsText}`}
                                href={importErrorLogPageLink}
                                
                            >
                                {props.fields.importErrorLogsText}
                            </Link>)
                        }
                         
                    </ListStyle>
                </StyledWrapper>
                <StyledWrapper {...customCssLinkWrapper}>
                    <Zone contentId={props.id} zoneName="DSGQuicklinks" />
                </StyledWrapper>
            </ManagedAccordionSection>
        </Accordion>
    );
};

const defaultCustomCss = `.navigation-list{
}

.navigation-list-item {
}

.navigation-list-link {
}
`;

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(NavigationList),
    definition: {
        group: "Basic",
        icon: "link-simple",
        fieldDefinitions: [
            {
                name: fields.depth,
                displayName: "Depth",
                editorTemplate: "IntegerField",
                defaultValue: 2,
                fieldType: "General",
                tab: basicTab,
            },
            {
                name: fields.nodeId,
                displayName: "Page",
                editorTemplate: "LinkField",
                defaultValue: {
                    value: "",
                    type: "Page",
                },
                fieldType: "General",
                allowUrls: item => false,
                allowCategories: item => false,
                tab: basicTab,
            },
            {
                name: fields.leftMargin,
                displayName: "Left Margin",
                editorTemplate: "IntegerField",
                defaultValue: 0,
                fieldType: "General",
                max: 100,
                min: 0,
                tab: basicTab,
            },
            {
                name: fields.marginBottom,
                displayName: "Margin Bottom",
                editorTemplate: "IntegerField",
                defaultValue: 0,
                fieldType: "General",
                max: 100,
                min: 0,
                tab: basicTab,
            },
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
            {
                name: fields.openLinkInNewWindow,
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                fieldType: "General",
                displayName: "Pay My Bill Text",
                name: fields.payMyBillText,
                editorTemplate: "TextField",
                defaultValue: "Online Bill Pay",
                sortOrder: 1,
            },
            {
                fieldType: "General",
                displayName: "Import Error Logs Text",
                name: fields.importErrorLogsText,
                editorTemplate: "TextField",
                defaultValue: "Import Error Logs View",
                sortOrder: 1,
            },
            {
                name: fields.importErrorLogsLink,
                displayName: "Import Error Logs Page",
                editorTemplate: "LinkField",
                defaultValue: {
                    value: "",
                    type: "Page",
                },
                fieldType: "General",
                allowUrls: item => false,
                allowCategories: item => false,
                tab: basicTab,
                sortOrder: 1,
            },
        ],
    },
};

export default widgetModule;
